<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PFormationEntete'
});
</script>
<template>
  <ka-container
    code="p-formation-entete"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Container Titre -->
    <ka-container code="container-titre">
      <!-- Container Textes -->
      <ka-container code="container-textes">
        <ka-text code="h-1">
          <h1 v-html="componentInstance.$h1.value" />
        </ka-text>
        <!-- Conteneur -->
        <ka-container code="conteneur">
          <!-- Conteneur Arg -->
          <ka-container code="conteneur-arg">
            <ka-icon
              code="icone"
              value="i-fa-solid:hand-holding-heart" />
            <ka-text code="formation-ultra-personnalisee">
              <span v-html="t('pFormationEntete.containerTitre.containerTextes.conteneur.conteneurArg.formationUltraPersonnalisee.value', `<strong>Formation ultra personnalisée</strong> qui se base sur vos objectifs avec la rédaction d'un programme de formation sur-mesure.`)" />
            </ka-text>
          </ka-container>
          <!-- Conteneur Arg -->
          <ka-container code="container-1">
            <ka-icon
              code="icon-1"
              value="i-fa-solid:user-check" />
            <ka-text
              code="texte"
              :value="componentInstance.$texte.value" />
          </ka-container>
          <!-- Conteneur Arg -->
          <ka-container code="container-2">
            <ka-icon
              code="icon-2"
              value="i-fa-solid:rocket" />
            <ka-text code="k-20-de-theorie-et-80">
              <span v-html="t('pFormationEntete.containerTitre.containerTextes.conteneur.container2.k20DeTheorieEt80.value', `20% de théorie et 80% de mise en pratique directement dans votre entreprise sur votre projet en cours.`)" />
            </ka-text>
          </ka-container>
          <!-- Conteneur Arg -->
          <ka-container code="container-3">
            <ka-icon
              code="icon-3"
              value="i-fa-solid:file-signature" />
            <ka-text code="matchers-se-charge">
              <span v-html="t('pFormationEntete.containerTitre.containerTextes.conteneur.container3.matchersSeCharge.value', `Matchers se charge de toutes les démarches administratives pour débloquer les financements dont votre entreprise peut bénéficier. `)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-button
          code="button-1"
          :options="{
            ripple: true,
            href: `/experts`,
            ariaLabel: `button 1`,
            click: componentInstance.button1Click
          }"
          :value="componentInstance.$button1.value" />
      </ka-container>
      <!-- Container formulaire -->
      <ka-container code="container-formulaire">
        <ka-iframe
          code="formulaire"
          :options="{
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            }
          }"
          value="https://share.hsforms.com/1DrO5vSzUQ8GoFeWzacw2Fg2xvix"
          inner />
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pFormationEnteteComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c7')
const component = pFormationEnteteComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  h1?: Nullable<string>
  button1?: Nullable<string>
  texte?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  h1: 'Formation en SEO - référencement',
  button1: 'Rechercher un expert',
  texte: 'La formation est réalisée par un<strong> expert en SEO</strong> issu d\'une entreprise à succès.',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:h1',
  'update:button1',
  'update:texte'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    h1: true,
    button1: true,
    texte: true
  }
})
</script>
